// Monitoramento de erros no browser. Espelha lib/synexis/sentry_scrubber.rb: mexeu num, mexa no
// outro. Substitui o antigo rollbar.js, preservando o que ele protegia e fechando o que ele deixava
// passar.
//
// POR QUE O CUIDADO: este pack roda no layout `form` e na tela de desenhar assinatura, ou seja, nas
// paginas /s/<slug>, /d/<slug> e /p/<slug> — cujo PROPRIO ENDERECO e a credencial de acesso ao
// documento (slug = SecureRandom.base58(14), sem login). Mandar a URL para um terceiro e mandar o
// acesso junto.
//
// O rollbar.js truncava o slug em 5 caracteres e so nas rotas /[sdep]/: deixava passar ~29 bits e
// nao cobria /esign, /verify nem /file. Aqui a URL vira so a familia da rota, o que nao depende de
// manter uma lista de rotas secretas em dia — rota nova nao vaza por omissao.
import {
  init,
  dedupeIntegration,
  eventFiltersIntegration,
  functionToStringIntegration,
  globalHandlersIntegration,
  linkedErrorsIntegration,
  captureMessage
} from '@sentry/browser'

const dsn = document.querySelector('meta[name="sentry-dsn"]')?.getAttribute('content')

// '/s/aBcDeFgHjKmNpQ' -> '/s'. Nenhuma rota do app tem parametro no primeiro segmento (todos sao
// literais estaticos), entao a familia e sempre segura de manter.
const routeFamily = (pathname) => `/${pathname.split('/').find(Boolean) ?? ''}`

// Erro em <script> INLINE (ex.: qualified_signatures/status, servido em /esign/<slug>/status) faz o
// browser usar a URL DO DOCUMENTO como filename do frame — ou seja, a stack trace carrega o slug
// mesmo com event.request ja tratado. Reduz esses frames a familia da rota, preservando os assets
// de /packs/ inteiros (e onde mora o codigo, e o nome do arquivo e o que serve para depurar).
const safeFrameFilename = (filename) => {
  if (typeof filename !== 'string' || !filename.startsWith(window.location.origin)) return filename

  const { pathname } = new URL(filename)

  return pathname.startsWith('/packs/') ? filename : window.location.origin + routeFamily(pathname)
}

if (dsn) {
  init({
    dsn,
    environment: 'production',
    sendDefaultPii: false, // = captureIp: false do rollbar.js
    maxBreadcrumbs: 0, // = payload.body.telemetry = [] do rollbar.js

    // Allowlist explicita em vez dos defaults. Os defaults do v10 incluem httpContext (copia
    // location.href para event.request.url), breadcrumbs (instrumenta fetch/history/DOM) e
    // browserApiErrors — todos capturariam a URL de assinatura por algum caminho. Ficam de fora;
    // a URL segura e montada a mao no beforeSend abaixo. Lista explicita tambem impede que uma
    // integracao nova entre sozinha numa atualizacao do SDK.
    defaultIntegrations: false,
    integrations: [
      globalHandlersIntegration(), // erro nao tratado + promise rejeitada: a razao de existir
      eventFiltersIntegration(), // faz o ignoreErrors abaixo valer
      dedupeIntegration(),
      linkedErrorsIntegration(),
      functionToStringIntegration()
    ],

    // Ruido de rede/permissao, nao acionavel — herdado do rollbar.js.
    ignoreErrors: [
      /Failed to fetch/i,
      /NetworkError/i,
      /Load failed/i,
      /Clipboard write is not allowed/i
    ],

    beforeSend (event) {
      // Sem httpContextIntegration o SDK nao monta event.request; montamos so o que e seguro.
      event.request = { url: window.location.origin + routeFamily(window.location.pathname) }

      event.exception?.values?.forEach((value) => {
        value.stacktrace?.frames?.forEach((frame) => {
          frame.filename = safeFrameFilename(frame.filename)
        })
      })

      return event
    }
  })

  // Os componentes de assinatura reportam 'Canvas blocked' (o signatario nao consegue assinar) e
  // vivem em outro pack, entao chegam aqui pelo global — mesmo padrao que o rollbar.js usava. So
  // definido quando ha DSN: `window.Sentry?.captureMessage(...)` vira no-op sem ele.
  window.Sentry = { captureMessage }
}
